import BpkText, {
  TEXT_STYLES,
  TEXT_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import withErrorBoundary from '../ErrorBoundary';

import type { FlightPricesDisclaimerTextProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLES from './FlightPricesDisclaimerText.module.scss';

const FlightPricesDisclaimerText = ({
  disclaimer,
}: FlightPricesDisclaimerTextProps) => (
  <div className={STYLES.FlightPricesDisclaimerText}>
    <div className={STYLES.FlightPricesDisclaimerText__main}>
      <BpkText
        tagName="p"
        color={TEXT_COLORS.textPrimary}
        textStyle={TEXT_STYLES.base}
        className={STYLES.FlightPricesDisclaimerText__text}
        data-testid="flightPricesDisclaimerText"
      >
        {disclaimer}
      </BpkText>
    </div>
  </div>
);

const FlightPricesDisclaimerTextWithErrorBoundary = withErrorBoundary(
  FlightPricesDisclaimerText,
  'flight-prices-disclaimer-text-component',
);
export default FlightPricesDisclaimerTextWithErrorBoundary;
